import { useEffect } from "react"

import csComEstApi from "./csComEstApi"

// セッションが切れて部品リストや見積が消えないようにするため20分毎にリクエストを送る
const useKeepSession = () => {
  useEffect(() => {
    // 20分
    const interval = 20 * 60 * 1000
    const timerId = window.setInterval(csComEstApi.ping, interval)

    return () => clearInterval(timerId)
  }, [])
}

export default useKeepSession
